import { NgModule } from '@angular/core';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GetPastImageInfoService } from './api-services/get-past-image-info.service';
import { RegistPastImageService } from './api-services/regist-past-image.service';
import { KYMW1705Component } from './kymw1705.component';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';

/**
 * 過去画像登録画面 モジュール設定クラス
 *
 * @export KYMW1705Module
 * @class KYMW1705Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule,
  ],
  declarations: [
    KYMW1705Component
  ],
  providers: [
    GetPastImageInfoService,
    RegistPastImageService,
  ],
})

export class KYMW1705Module { }
